/**
 * Given an attribute type, this will create a formatter type name
 * to be used by the models, editors, and formatter factory.
 * This returns 'attr.formatter.${type}'
 */
function getFormatterTypeForType(type) {
  return `attr.formatter.${type}`;
}

/**
 * Given the number v and the max number of decimals allowed, 
 * this will trim (using Number.toFixed()) the value to only
 * those number of decimals
 */
function trimDecimals(v, max) {
  const tv = v.toString();
  const idx = tv.indexOf('.');
  if (idx < 0) {
    return tv;
  }
  const numDec = tv.length - idx - 1;
  if (numDec > max) {
    return v.toFixed(max);
  }
  return tv;
}
export default {
  getFormatterTypeForType,
  trimDecimals
};